// @ts-strict

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { StatisticsService } from '@pages/statistics/statistics.service';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { IDateRange, StatisticsDatePickers } from '../statistics-top-menu-new.component';
import { StatisticsTopMenuNewService } from '../statistics-top-menu-new.service';
import { AvailableDatePeriod } from './date-picker-sidebar/statistics-date-picker-sidebar.component';
import { StatisticsDatePickerService } from './date-picker/custom-date-picker.service';

const MAX_USER_DATE_RANGE = 365;

@Component({
  selector: 'app-statistics-range-picker',
  templateUrl: './statistics-range-picker.component.html',
  styleUrls: ['./statistics-range-picker.component.scss']
})
export class StatisticsRangePickerComponent implements OnInit {
  @Input() currentDatePicker: StatisticsDatePickers = 'default';
  @Input() dateRanges: IDateRange[] = [];
  @Input() selectedPeriod: AvailableDatePeriod = 'last_7_days';

  @Output() closeRangePickerOut = new EventEmitter<boolean>();

  @Output() selectedDateRange = new EventEmitter<IDateRange>();

  public selectedPeriodDates?: { range: AvailableDatePeriod; dateFrom: NgbDate; dateTo: NgbDate | null } = undefined;
  public rangePickerOpen = false;

  public maxDateRange: number = 0;
  public maxUserDateRange: number = MAX_USER_DATE_RANGE;

  public isDateRangeTooWide = false;

  public rangeTooWideCompare = false;

  public beginDate?: Date;

  private destroy$ = new Subject<void>();

  get isComparePicker(): boolean {
    return this.currentDatePicker === 'compare';
  }

  constructor(
    private readonly statisticsTopMenuNewService: StatisticsTopMenuNewService,
    private readonly statisticsDatePickerService: StatisticsDatePickerService
  ) {}

  ngOnInit(): void {
    this.statisticsTopMenuNewService
      .maxCompareDaysRangeAllowed$()
      .pipe(
        tap(({ maxDaysAllowed }) => {
          if (this.isComparePicker) {
            this.maxDateRange = maxDaysAllowed;
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  public setSelectedPeriodDates = (selectedPeriodDates: { dateFrom: NgbDate; dateTo: NgbDate | null }) => {
    const { dateFrom, dateTo } = selectedPeriodDates;

    if (this.isComparePicker && dateTo) {
      const selectedCompareRangeDiff = this.statisticsDatePickerService.calcDaysDiff(dateFrom, dateTo) + 1;

      this.rangeTooWideCompare = selectedCompareRangeDiff !== this.maxDateRange;
    }

    if (dateTo) {
      this.isDateRangeTooWide = this.checkIfRangeTooWide({ dateFrom, dateTo });
    }

    if (this.isDateRangeTooWide || this.rangeTooWideCompare) {
      return;
    }

    this.selectedPeriodDates = { ...selectedPeriodDates, range: this.selectedPeriod };
  };

  public setSelectedSidebarPeriod = (period: AvailableDatePeriod, resetUserDateRange = false) => {
    if (period === 'user' && resetUserDateRange) this.resetUserDateRange();

    this.selectedPeriod = period;
  };

  public closeRangePicker(target?: HTMLElement | void): void {
    if (target && target.classList.contains('outsideDay')) {
      this.rangePickerOpen = true;

      return;
    }
    if (this.rangePickerOpen) {
      this.closeRangePickerOut.next(true);
    }
    this.rangePickerOpen = true;
  }

  public emitDateRange(): void {
    if (this.selectedPeriodDates) {
      const { dateFrom, dateTo, range } = this.selectedPeriodDates;

      if (dateTo) this.selectedDateRange.emit({ dateFrom, dateTo, range });
    }
  }

  private resetUserDateRange(): void {
    this.dateRanges = this.dateRanges.filter(({ range }) => range !== 'user');
  }

  private checkIfRangeTooWide = (selectedPeriodDates: { dateFrom: NgbDate; dateTo: NgbDate }): boolean => {
    return this.statisticsDatePickerService.calcDaysDiff(selectedPeriodDates.dateFrom, selectedPeriodDates.dateTo) > this.maxUserDateRange;
  };
}
